
export const urlData = {
  home: '/',
  service:'/service',
  case: '/case',
  inspiration: '/list/inspiration',
  products: '/list/product',
  enquiry: '/smart',
  designTools: '/design-tools',
  collect: '/collection',
  mall: 'https://b.zhulogic.com/mall',
  projects: '/project-list',
  order: '/my-order',
  msg: '/my-message',
  my: '/my-center',
  login: `/sign?redirect=`,
  myEgg: `/my-egg` /* 我的恐龙蛋 */,
  regest: `/my/personal/accountSetting?index=2` /* 实名认证 */,
  designer: `/my/personal/accountSetting?index=2` /* 设计师认证 介绍页面 */,
  favorite: `/my-collect` /* 我的收藏 */,
  vip: `/my/personal/vip` /* 会员俱乐部 */,
  about: `/about` /* 关于我们 */,
  download: `/download` /* app下载 */,
  cooperate: `/cooperate` /* 商务合作 */,
  work: `/work-location` /* 商务合作 */,
  myPrice: '/my-price' /* 我的询价 */,
  myProject: '/my-project' /* 我的项目 */,
  design:'/design-tools', /*设计工具*/
  so:'/so' /*聚合搜图*/
}